var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Container, Grid, GridColumn, Image, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import DiilCustomerRequiredNotice from '../auth/DiilCustomerRequiredNotice';
import BannerContainer from '../banner/BannerContainer';
import DebtNotice from '../frontpage/DebtNotice';
import FrontPageBlocks from '../frontpage/FrontPageBlocks';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { createGaEvent } from '../util/GaUtil';
import { MandateType } from '../config/mandate';
import Config from '../Config';
import { injectStores } from '../util/StoresUtil';
import LoggingApi from '../api/LoggingApi';
let FrontPage = class FrontPage extends Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "clickedOnTakeNotices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        LoggingApi.postLog(location.pathname);
    }
    render() {
        const { translate } = this.translateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(DiilCustomerRequiredNotice, null),
            React.createElement(DebtNotice, null),
            this.shouldRenderPartyPrivacyProfileNotice && this.renderAgreementsNotice(),
            React.createElement(Container, null,
                React.createElement(Grid, { align: ['center-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(Image, { srcset: translate('frontPage.updateSelfserviceImageUrl'), width: 150, alt: "SelfService" })),
                    React.createElement(GridColumn, { width: ['sm-5'] },
                        React.createElement("div", { className: "text" },
                            React.createElement("h1", null, translate('frontPage.welcomeToSelfservice'))))),
                React.createElement(Separator, { spacing: "medium", color: "invisible" }),
                React.createElement(FrontPageBlocks, null)),
            React.createElement(BannerContainer, { slug: "selfservice-banner" })));
    }
    componentDidMount() {
        this.listenToCustomerChange();
    }
    listenToCustomerChange() {
        reaction(() => this.ssoStore.customer, async () => {
            if (this.ssoStore.customer) {
                await Promise.all([
                    this.partyPrivacyProfileStore.loadPartyPrivacyProfileResource(true),
                    this.mandateStore.loadMandateInfo([MandateType.LEGAL, MandateType.SERVICE])
                ]);
            }
        }, { fireImmediately: true });
    }
    get shouldRenderPartyPrivacyProfileNotice() {
        if (this.partyPrivacyProfileStore.isFetching() || this.clickedOnTakeNotices) {
            return false;
        }
        if (this.ssoStore.isDealer) {
            return this.partyPrivacyProfileStore.shouldUserRefreshAgreements;
        }
        return !this.partyPrivacyProfileStore.hasProfile;
    }
    renderAgreementsNotice() {
        const { translate } = this.translateStore;
        return (React.createElement(Container, null,
            React.createElement(Grid, { align: ['center-xs', 'middle-xs'] },
                React.createElement(GridColumn, { width: ['xs-12', 'sm-12'] }, this.ssoStore.isDealer ? (React.createElement(Notice, { type: "employee", align: "center" },
                    React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                        React.createElement(GridColumn, { width: ['xs', 'max-sm'] }, translate('consentsMissing.dealer.notice')),
                        React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                            React.createElement(Button, { text: translate('consentsMissing.dealer.takeConsents'), iconRight: "#arrow-right", onClick: this.onTakeNoticesClick }))))) : (React.createElement(Notice, { align: "center" },
                    React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                        React.createElement(GridColumn, { width: ['xs', 'max-sm'] }, translate('consentsMissing.customer.notice')),
                        React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                            React.createElement(Button, { text: translate('consentsMissing.customer.takeConsents'), iconRight: "#arrow-right", onClick: this.onTakeNoticesClick }))))))),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
    }
    onTakeNoticesClick() {
        this.clickedOnTakeNotices = true;
        window.open(Config.offersSettingsUrl, '_blank');
        createGaEvent({
            eventCategory: 'Teenindus - Avaleht',
            eventAction: 'GDPR lehele suundumine',
            eventLabel: this.ssoStore.isDealer ? 'consentsMissing.dealer.takeConsents' : 'consentsMissing.customer.takeConsents'
        });
    }
};
__decorate([
    observable
], FrontPage.prototype, "clickedOnTakeNotices", void 0);
__decorate([
    computed
], FrontPage.prototype, "shouldRenderPartyPrivacyProfileNotice", null);
__decorate([
    action.bound
], FrontPage.prototype, "onTakeNoticesClick", null);
FrontPage = __decorate([
    injectStores,
    observer
], FrontPage);
export default FrontPage;
